module.exports = __webpack_public_path__ + "img/plus-icon.cb2dd681.svg";